import firebase from "firebase/compat/app";

const setGroupInfo = async function(competitionId, groupId, item) {
  let db = firebase.firestore();
  let result;
  if (competitionId != undefined && groupId != undefined ) {
    result = await db
      .collection("wellness_competition")
      .doc(competitionId)
      .collection("groups")
      .doc(groupId)
      .set(item, { merge: true });
  }
  return result;
};

export default setGroupInfo;
